<template>
  <div class="form-list">
    <el-form
      ref="form"
      :model="details"
      :rules="rules"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="姓名">
        {{ details.student_name }}

        <router-link :to="studentDetailTo(details.student_id)" class="primary-color">查看学员主页</router-link>
      </el-form-item>
      <el-form-item label="昵称">
        {{ details.nickname }}
      </el-form-item>
      <el-form-item label="真人自拍">
        <v-avatar :value="details.selfie" :size="100"/>
      </el-form-item>
      <el-form-item label="小程序头像">
        <v-avatar :value="details.avatar" :size="100"/>
      </el-form-item>
      <el-form-item label="注册时间">
        {{ details.register_time | timeToYmdHi }}
      </el-form-item>
      <el-form-item label="注册来源">
        {{ details.register_store_name }}
      </el-form-item>
      <el-form-item label="手机号">
        {{ details.phone }}
      </el-form-item>
      <el-form-item label="会员号">
        {{ details.card_number }}
      </el-form-item>
      <el-form-item label="实名证件号" prop="id_number">
        {{ details.id_number || '-' }}
      </el-form-item>
      <el-form-item label="拥有课卡数量" prop="id_number">
        {{ details.card_count || 0 }}
      </el-form-item>

      <el-form-item label="申请时间">
        {{ details.add_time | timeToYmdHi }}
      </el-form-item>

      <el-form-item label="申请者">
        <v-avatar-nickname
          :value="details.apply_avatar"
          :nickname="details.apply_nickname"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="申请门店">
        {{ details.store_name }}
      </el-form-item>

      <el-form-item label="注销原因">
        {{ details.delete_cause }}
      </el-form-item>

      <el-form-item label="审核状态">
        <template v-if="!isLoading && !isLoadingError">
          <span
            v-for="state in findApplyState(details.apply_state)"
            :key="`student-deletion-request-state${state.value}`"
          >
            <span :class="`${state.tagType}-color`">{{ state.name }}</span>
          </span>
        </template>
      </el-form-item>

      <template v-if="details.update_time && (canViewReviewInfo)">
        <el-form-item
          :label="`${details.apply_state === applyStates.revoked.value ? '撤回' : '审核'}时间`"
        >
          {{ details.update_time | timeToYmdHi }}
        </el-form-item>

        <el-form-item v-if="examinedStates.includes(details.apply_state)" label="审核人">
          <v-avatar-nickname
            :value="details.update_avatar"
            :nickname="details.update_nickname"
            :is-center="false"
          />
        </el-form-item>
      </template>

      <el-form-item label="驳回原因" v-if="details.apply_state === applyStates.rejected.value && (canViewReviewInfo)">
        {{ details.reject_cause }}
      </el-form-item>

      <template
        v-if="!isLoading && !isLoadingError && details.apply_state === applyStates.review.value"
      >
        <template v-if="isAdministrator">
          <el-form-item label="审核结果">
            <el-radio v-model="isReject" :label="0" :disabled="isExamining">通过</el-radio>
            <el-radio v-model="isReject" :label="1" :disabled="isExamining">驳回</el-radio>
          </el-form-item>

          <el-form-item v-if="isReject" label="驳回原因" prop="reject_cause">
            <el-input
              class="clearable-word-limit-input"
              v-model="details.reject_cause"
              maxlength="144"
              placeholder="请输入驳回原因"
              show-word-limit
              clearable
              :disabled="isExamining"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleExamine" :loading="isExamining">完成审核</el-button>
            <el-button @click="studentDeletionRequestListBack">返回</el-button>
          </el-form-item>
        </template>

        <el-form-item v-else>
          <el-button type="primary" @click="handleRevoke" :loading="isRevoking">撤销</el-button>
          <el-button @click="studentDeletionRequestListBack">返回</el-button>
        </el-form-item>
      </template>
      <el-form-item v-else>
        <el-button @click="studentDeletionRequestListBack">返回</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, pass, reject, revoke } from '@/api/student-deletion-request';
import { mapGetters } from 'vuex';
import { applyStates, findApplyState } from '@/enums/applyStates';

export default {
  name: RouteConfig.studentDeletionRequestDetail.name,
  data: () => ({
    studentDeletionRequestListBack: RouteConfig.studentDeletionRequestList.back,
    studentDeletionRequestListPush: RouteConfig.studentDeletionRequestList.push,
    studentDetailTo: RouteConfig.studentDetail.to,
    isLoading: false,
    isLoadingError: false,
    isExamining: false,
    isRevoking: false,
    isReject: 0,
    applyStates,
    examinedStates: [applyStates.rejected.value, applyStates.passed.value],
    details: {
      apply_state: applyStates.review.value,
      add_time: 0,
      update_time: 0,
      register_time: '',
      student_id: 0,
      student_name: '',
      register_store_name: '',
      selfie: '',
      avatar: '',
      phone: '',
      card_number: '',
      id_number: '',
      card_count: 0,

      nickname: '',
      apply_avatar: '',
      apply_nickname: '',
      update_nickname: '',
      update_avatar: '',
      store_name: '',
      delete_cause: '',
      reject_cause: '',
      store_id: 0,
    },
    rules: {
      reject_cause: [{required: true, message: '请输入驳回原因', trigger: 'change'}],
    },
  }),

  computed: {
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.details.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
  },

  beforeMount() {
    this.show();
  },

  methods: {
    findApplyState,
    async show() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      const { details } = this;
      const newDetails = Object.keys(details).reduce((acc, key) => {
        if (key in data) acc[key] = data[key];
        return acc;
      }, {});
      Object.assign(details, newDetails);
      this.isLoading = false;
    },

    handleExamine() {
      if (this.isExamining) return;
      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;
        this.isExamining = true;
        this.isReject ? this.handleReject() : this.handlePass();
      });
    },

    async handlePass() {
      const { isError } = await pass(this.id, { update_time: this.details.update_time });
      this.isExamining = false;
      if (!isError) this.studentDeletionRequestListPush({ apply_state: applyStates.passed.value });
    },

    async handleReject() {
      const { isError } = await reject(this.id, { update_time: this.details.update_time, reject_cause: this.details.reject_cause });
      this.isExamining = false;
      if (!isError) this.studentDeletionRequestListPush({ apply_state: applyStates.rejected.value });
    },

    async handleRevoke() {
      if (this.isRevoking) return;
      this.isRevoking = true;
      const { isError } = await revoke(this.id, { update_time: this.details.update_time });
      this.isRevoking = false;
      if (!isError) this.studentDeletionRequestListPush({ apply_state: applyStates.revoked.value });
    },
  },
};
</script>
